import {HasNotifyBaseMixin} from "../../widget/mixins/HasNotifyBaseMixin.jsx";
import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";

export default class ResourceNotifyTab extends HasNotifyBaseMixin(ResourceEditTabBase) {
  static get $name() {
    return "ResourceNotifyTab";
  }

  static get type() {
    return "resourcenotifytab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.resourceEditorNotifyGridState;
  }

  get recordType() {
    return "resourceId";
  }

  get entityNamePlaceholder() {
    return "resource";
  }
}

ResourceNotifyTab.initClass();
